<template>
  <div>
    <sui-form>
    <sui-form-fields>
      <sui-form-field>
        <sui-dropdown placeholder="-- select --" selection :options="options"
                      v-model="selected" style="width: 250pt" @input="serviceSelected" />
      </sui-form-field>
    </sui-form-fields>
      <sui-form-fields v-if="url">
        <sui-form-field>
          <sui-label :color="selectedMethod === 'post' ? 'violet' : 'teal'" basic style="line-height: 1.9em">
            {{ selectedMethod }}
          </sui-label>
        </sui-form-field>
        <sui-form-field>
          <sui-input v-model="url" style="width: 300pt"/>
        </sui-form-field>
        <sui-form-field v-if="selectedMethod === 'post'">
          <sui-input v-model="postData" style="width: 350pt"/>
        </sui-form-field>
        <sui-form-field>
          <sui-button type="button" color="blue" @click="loadData">Go</sui-button>
        </sui-form-field>
        <sui-form-field v-if="took">
          <sui-label tag style="line-height: 1.9em">
            Request took {{took}}ms
          </sui-label>
        </sui-form-field>
      </sui-form-fields>
    </sui-form>
    <div style="white-space: pre">
      <json-viewer v-if="response" class="json-viewer" :value="response" :expand-depth="3" copyable />
    </div>
  </div>
</template>

<script>
import AppService from "@/services/App";
import JsonViewer from 'vue-json-viewer'

const appService = new AppService()

export default {
  name: "ApiTest",
  components: {JsonViewer},
  data: function () {
    return {
      selected: null,
      selectedMethod: null,
      url: null,
      postData: null,
      options: [],
      methods: [
        {text: "GET", value: 'get'},
        {text: "POST", value: 'post'},
      ],
      response: null,
      took: null,
      lastParamValue: null,
    }
  },
  async mounted() {
    appService.apiTester().then((response) => {this.options = response.data.data}).catch(this.processError)
  },
  methods: {
    serviceSelected(val) {
      let valSplit = val.split(":")
      if (valSplit.length === 1) {
        this.selectedMethod = 'get';
        this.url = valSplit[0]
        return
      }
      if (valSplit.length === 2) {
        this.selectedMethod = valSplit[0]
        this.url = valSplit[1]
        return
      }
      if (valSplit.length === 3) {
        this.selectedMethod = valSplit[0]
        this.url = valSplit[1]
        this.postData = valSplit[2]
        return
      }
    },
    async loadData() {
      let url = this.url
      let method = this.selectedMethod
      let pattern = /{(.*)}/
      let match = url.match(pattern)
      if ((match || []).length > 1) {
        let propertyName = match[1];
        let value = prompt(`enter ${propertyName}`, this.lastParamValue || "999999999999999")
        if (!value) {
          return
        }
        this.lastParamValue = value
        url = url.replaceAll(match[0], value)
      }
      this.response = null;
      if (method === "post") {
        let data = {}
        for (const entry of new URLSearchParams(this.postData).entries()) {
          data[entry[0]] = entry[1]
        }
        appService.postRequest(url, data).then(this.processResponse()).catch(this.processError)
        return
      }
      appService.getRequest(url).then(this.processResponse()).catch(this.processError)
    },
    processError(err) {
      this.response = err.response
    },
    processResponse() {
      this.took = null;
      let timeStart = new Date()
      return (response) => {
        let timeEnd = new Date();
        this.response = response.data.data
        this.took = timeEnd.getTime() - timeStart.getTime()
      }
    },
  }
}
</script>

<style scoped>
  .json-viewer {
    zoom: 0.8;
  }
</style>
